import React from "react";
import { connect } from "react-redux";
import { setPublicationSettings } from "../../store/actions/project";
import API from "../../utils/axios";

import Typography from "@material-ui/core/Typography";
import { Box } from "@material-ui/core";
import Switch from "@material-ui/core/Switch";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { remCalc } from "../../utils/helpers";
import { client } from "../map/DriverMarkers";

const useStyles = makeStyles(theme => ({
  title: {
    fontSize: remCalc(10),
    textTransform: "uppercase",
    letterSpacing: "0.16rem",
    lineHeight: "0.75rem",
    fontWeight: 500,
    marginBottom: theme.spacing(2)
  },
  label: {
    fontSize: remCalc(15)
  }
}));

function PublishSettings({
  settings,
  projectId,
  setPublicationSettings,
  routes
}) {
  const classes = useStyles();

  const {
    fulfill_stops_in_any_order,
    allowed_to_call_recipient,
    require_name_with_signature
  } = settings;

  const handleSwitchChange = e => {
    const newSettings = { ...settings, [e.target.name]: e.target.checked };

    setPublicationSettings(newSettings);

    API.patch(`/v1/projects/${projectId}/settings`, newSettings)
      .then(res => {
        routes.forEach(route => {
          client.send(
            JSON.stringify({
              type: "publication_settings",
              settings: newSettings,
              route_id: route.id
            })
          );
        });
      })
      .catch(error => console.log(error));
  };

  return (
    <Box py={3} pl={2} pr={3}>
      <Typography color="secondary" className={classes.title}>
        Driver is allowed to
      </Typography>

      {/* Fulfill stops in any order */}
      <Box
        height={28}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Typography
          component="label"
          className={classes.label}
          htmlFor="input-any-order"
          variant="body1"
        >
          Fulfill the stops in any order
        </Typography>

        <Switch
          inputProps={{ id: "input-any-order" }}
          data-cy="fulfillStops-switch"
          name="fulfill_stops_in_any_order"
          onChange={handleSwitchChange}
          checked={fulfill_stops_in_any_order}
          color="primary"
        />
      </Box>

      {/* Call customer */}
      <Box
        height={28}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={4}
      >
        <Typography
          component="label"
          className={classes.label}
          htmlFor="input-call-customer"
          variant="body1"
        >
          Call the customer
        </Typography>

        <Switch
          inputProps={{ id: "input-call-customer" }}
          data-cy="callCustomer-switch"
          name="allowed_to_call_recipient"
          onChange={handleSwitchChange}
          checked={allowed_to_call_recipient}
          color="primary"
        />
      </Box>

      <Typography color="secondary" className={classes.title}>
        Proof of delivery
      </Typography>

      {/* Require signature name */}
      <Box
        height={28}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography
          component="label"
          className={classes.label}
          htmlFor="input-signature-name"
          variant="body1"
        >
          Name obligatory during signature capture
        </Typography>

        <Switch
          inputProps={{ id: "input-signature-name" }}
          data-cy="signature-switch"
          name="require_name_with_signature"
          onChange={handleSwitchChange}
          checked={require_name_with_signature}
          color="primary"
        />
      </Box>
    </Box>
  );
}

const mapStateToProps = state => ({
  settings: state.project.publication_settings || {},
  projectId: state.project.id,
  routes: state.project.solution?.routes || []
});

export default connect(mapStateToProps, { setPublicationSettings })(
  PublishSettings
);
